import React from 'react'

const Footer = () => {
  return (
    <div>
      <div className="row">
        <footer>
          <div className="siteHeader d_flex flex-wrap">
            <div className="headerWrap">
              <p>Copyright © 2024 Prabhu Studio</p>
            </div>
            <div className="headerWrap">
              <p>Developed By <a target="_blank" href="https://www.prabhuproducts.com/">Prabhu Products</a>
              </p>
            </div>
          </div>
        </footer>
      </div>
    </div>
  )
}

export default Footer
